export interface StateItem {
  slug: string;
  name: string;
  code: string;
  listingCount: number;
  listingCountIsCapped?: boolean;
}

const US_REGIONS: Record<string, string[]> = {
  Northeast: ["CT", "DE", "MA", "MD", "ME", "NH", "NJ", "NY", "PA", "RI", "VT"],
  Southeast: ["AL", "AR", "FL", "GA", "KY", "LA", "MS", "NC", "SC", "TN", "VA", "WV"],
  Midwest: ["IA", "IL", "IN", "KS", "MI", "MN", "MO", "ND", "NE", "OH", "SD", "WI"],
  Southwest: ["AZ", "NM", "OK", "TX"],
  West: ["AK", "CA", "CO", "HI", "ID", "MT", "NV", "OR", "UT", "WA", "WY"],
};

export function filterStatesByQuery(
  states: StateItem[],
  searchQuery: string,
): StateItem[] {
  if (!searchQuery.trim()) return states;

  const query = searchQuery.toLowerCase();
  return states.filter(
    (state) =>
      state.name.toLowerCase().includes(query) ||
      state.code.toLowerCase().includes(query),
  );
}

export function groupStatesByRegion(states: StateItem[]): {
  groupedStates: Array<{ region: string; states: StateItem[] }>;
  unmappedStates: StateItem[];
} {
  const statesByCode = new Map<string, StateItem>();
  for (const state of states) {
    statesByCode.set(state.code, state);
  }
  const groupedStates = Object.entries(US_REGIONS)
    .map(([region, codes]) => ({
      region,
      states: codes
        .map((code) => statesByCode.get(code))
        .filter((state): state is StateItem => state !== undefined),
    }))
    .filter((group) => group.states.length > 0);
  const mappedCodes = new Set(Object.values(US_REGIONS).flat());
  const unmappedStates = states.filter((state) => !mappedCodes.has(state.code));
  return { groupedStates, unmappedStates };
}
